/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Button, Form, Card, Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./Settings.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import ImageCompressor from "react-image-file-resizer";
import withReactContent from "sweetalert2-react-content";
import {
  addDoc,
  collection,
  query,
  where,
  getDocs,
  serverTimestamp,
  doc,
  getDoc,
  updateDoc,
  Timestamp,
  increment,
} from "firebase/firestore";
import freeCountries from "../../utils/freeCountries.json";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { createNotification } from "../../api/Notifications";
import Account from "./Account";
import { useTranslation } from "react-i18next";
import axios from "axios";

function Plan() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const account = useSelector((state) => state.AccountReducer);
  const transaction = useSelector((state) => state.TransactionReducer);
  const store = useSelector((state) => state.StoreReducer);
  const subscription = useSelector(
    (state) => state.AccountReducer.subscription
  );
  const selectedCountry = store?.country || "الجزائر";
  const isAlgeria = selectedCountry === "الجزائر";
  let endDate = null;
  if (subscription?.endDate) {
    if (subscription.endDate.toDate) {
      // Si c’est un vrai Timestamp Firestore
      endDate = subscription.endDate.toDate();
    } else if (subscription.endDate._seconds) {
      // Si c’est un objet brut
      endDate = new Date(subscription.endDate._seconds * 1000);
    }
  }

  const plan = useSelector((state) => state.AccountReducer.subscription?.plan);
  const [showSideBar, setShowSideBar] = useState(true);
  const [nbrTransaction, setNbrTransaction] = useState(0);
  const userId = useSelector((state) => state.AccountReducer.id);
  const [isExist, setIsExist] = useState(true);
  const [userInvitedBy, setUserInvitedBy] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [hasPreviousTransaction, setHasPreviousTransaction] = useState(false);
  const isFreeCountry = freeCountries.includes(account?.country);

  useEffect(() => {
    if (isFreeCountry) {
      navigate("/FreeContent");
    }
  }, [isFreeCountry, navigate]);

  const fetchValidTransactions = () => {
    try {
      const validTransactions = transaction.filter((t) => t.isValid === 3);
      const nbrTransaction = validTransactions.length;
      setNbrTransaction(nbrTransaction);
      console.log("nbrTransaction", nbrTransaction);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des transactions valides:",
        error
      );
      return 0;
    }
  };

  useEffect(() => {
    // Run this function only when `transaction` or `account.user` changes
    fetchValidTransactions();
  }, [transaction, account.user]);

  // Function to check if `invitedBy` exists in Firebase and is not the same as the user's `callName`
  const checkInvitedByExists = async (invitedBy) => {
    if (!invitedBy.trim()) {
      setIsExist(true); // Allow submission when invitedBy is empty
      return true;
    }

    if (invitedBy === account?.callName) {
      setIsExist(false); // Prevent self-invitation
      return false;
    }

    try {
      // Make API request to check if the invitedBy exists
      const response = await fetch(
        "https://backend.foorweb.store/api/getAffiliate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ callName: invitedBy }),
        }
      );

      const data = await response.json();

      // Check if the response contains the user data and matches the callName
      const exists = data.callName === invitedBy;
      setUserInvitedBy(data.user);
      setIsExist(exists); // Update state with the result
      return exists;
    } catch (error) {
      console.error("Error checking invitedBy existence:", error);
      setIsExist(false);
      return false;
    }
  };

  // Function to handle invitedBy input change
  const handleInvitedByChange = async (e) => {
    const invitedByValue = e.target.value.trim(); // Trim spaces
    setFormData((prev) => ({ ...prev, invitedBy: invitedByValue }));

    // Check if invitedBy is the same as current user's call name
    if (invitedByValue === account?.callName) {
      setErrorMessage(t("ui.ownReferral"));
      setIsExist(false);
      return;
    }

    if (invitedByValue !== "") {
      const exists = await checkInvitedByExists(invitedByValue);
      if (!exists) {
        setErrorMessage(t("signup.referral.not_found"));
        setIsExist(false);
      } else {
        setErrorMessage("");
        setIsExist(true);

        // Apply remise if it's the first transaction
        if (!hasPreviousTransaction) {
          setFormData((prev) => ({
            ...prev,
            remise: 20, // Apply 20% remise
          }));
        } else {
          setIsExist(false);
          setErrorMessage(
            t("ui.returningCustomerCoupon")
          );
        }
      }
    } else {
      setIsExist(true);
      setErrorMessage("");
      setFormData((prev) => ({
        ...prev,
        remise: hasPreviousTransaction ? 0 : 20, // Ensure remise logic is maintained
      }));
    }
  };

  //const [step, setStep] = useState(1);
  const MySwal = withReactContent(Swal);

  const [formData, setFormData] = useState({
    plan: 0,
    planName: "الاساسية",
    order: "",
    unitPrice: 10,
    paymentMethod: isAlgeria ? 1 : 6,
    numberOfOrders: 100,
    invitedBy: "", // Will be fetched from Firestore
    total: 0,
    proof: "",
    timeStamp: serverTimestamp(),
    isValid: 2,
    remise: 0, // Default remise = 0%
    total1: 0,
  });
  console.log("formData", formData);

  // Fetch user data and check if it's their first transaction
  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return;

      try {
        if (account) {
          const invitedBy = formData.invitedBy || "";
          const hasTransaction = !transaction.empty;
          setHasPreviousTransaction(hasTransaction);
          // alert(hasTransaction);

          setFormData((prev) => ({
            ...prev,
            invitedBy,
            remise: !hasTransaction ? 20 : 0, // Apply remise only if no previous transaction
          }));
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [userId]);

  // Calculate base total
  useEffect(() => {
    const calculatedTotal = formData.numberOfOrders * formData.unitPrice;
    setFormData((prev) => ({
      ...prev,
      total: calculatedTotal,
    }));
  }, [formData.numberOfOrders, formData.unitPrice]);

  // Calculate total after remise
  useEffect(() => {
    const remiseAmount = (formData.total * formData.remise) / 100;
    setFormData((prev) => ({
      ...prev,
      total1: prev.total - remiseAmount,
    }));
  }, [formData.total, formData.remise]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [isSuraUploaded, setIsSuraUploaded] = useState(false);

  const uploadImage2 = async (e, type, index) => {
    const gallery = [];
    let count = 0;

    for (let i = 0; i < e.length; i++) {
      const file = e[i];
      const fileType = file.type;

      let dataImage = new FormData();

      if (fileType === "application/pdf") {
        // التعامل مع ملف PDF بدون ضغط
        dataImage.append("upload", file, new Date().getTime() + i + "main");
      } else {
        // Resize the image using ImageCompressor
        const uri = await new Promise((resolve) => {
          ImageCompressor.imageFileResizer(
            file, // input file
            Infinity, // max width
            Infinity, // max height
            "WEBP", // output format
            100, // quality
            0, // rotation
            (uri) => {
              resolve(uri);
            },
            "base64" // output type
          );
        });

        const blob = await fetch(uri).then((r) => r.blob());
        dataImage.append("upload", blob, new Date().getTime() + i + "main");
      }

      await axios
        .post(
          `https://octopus-app-i4ylg.ondigitalocean.app/upload`,
          dataImage,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then(function (response) {
          if (type === "main") {
            setFormData({ ...formData, proof: response.data.url });
          }
          if (i === e.length - 1) {
            setIsSuraUploaded(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const nextStep = () => {
    setStep({ ...steps, currentStep: steps.currentStep + 1 });
    window.scrollTo(0, 0);
  };

  const prevStep = () => {
    setStep({ ...steps, currentStep: steps.currentStep - 1 });
    window.scrollTo(0, 0);
  };
  const downpage = () => {
    document.getElementById("target").scrollIntoView({ behavior: "smooth" });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    let inputValue = event.target.value;
    if (!isNaN(inputValue) && parseInt(inputValue) >= 100) {
      setValue(inputValue);
    }
  };

  const handleClick = (event) => {
    const input = event.target.previousSibling;
    input.select();
    document.execCommand("copy");
  };

  const [steps, setStep] = useState({
    stepsItems: [
      t("PlanPage.steps.summary"),
      t("PlanPage.steps.payment_info"),
      t("PlanPage.steps.review"),
    ],
    currentStep: 1,
  });

  const points = useSelector((state) => state.AccountReducer.points);
  const allPoints = useSelector((state) => state.AccountReducer.allPoints);
  const conversionRate = 10;

  const [finalAmount, setFinalAmount] = useState(formData.total1 ?? 0);
  const [usedPoints, setUsedPoints] = useState(0);
  const [totalAccumulatedPoints, setTotalAccumulatedPoints] = useState(
    allPoints ?? 0
  );

  useEffect(() => {
    const userPointsInDZD = points * conversionRate;
    const discount = Math.min(userPointsInDZD, formData.total1 ?? 0);

    setFinalAmount((formData.total1 ?? 0) - discount);
    setUsedPoints(discount / conversionRate);
    setTotalAccumulatedPoints((allPoints ?? 0) + discount / conversionRate);
  }, [formData.total1, points, allPoints]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const originalAmount = formData.total1 ?? 0;
      const userPointsInDZD = points * conversionRate;
      const discount = Math.min(userPointsInDZD, originalAmount);
      const finalAmount = originalAmount - discount;
      const usedPoints = discount / conversionRate;
      const remainingPoints = Math.max(points - usedPoints, 0);

      const subscriptionType = formData.plan;

      const subscriptionPointsMap = {
        1: 10,
        2: 20,
        3: 30,
        4: 40,
        5: 50,
        6: 60,
      };
      const earnedPoints = subscriptionPointsMap[subscriptionType] || 0;

      // Save transaction with email, name, and phone
      const transactionRef = await addDoc(collection(db, "transaction"), {
        ...formData,
        isValid: nbrTransaction >= 2 ? 5 : 1,
        amount: finalAmount,
        user: account.user,
        userInvitedBy: userInvitedBy,
        email: account.email || "",
        points: earnedPoints,
        name: account.name || "",
        phone: account.phone || "",
        timestamp: serverTimestamp(),
      });
      console.log("nbrTransaction", nbrTransaction);

      if (nbrTransaction >= 2) {
        function getNewEndDate(planActuel, planVoulu, endDate, today) {
          const planDuration =
            {
              1: 30,
              2: 90,
              3: 365,
              5: 30,
              6: 90,
              7: 365,
            }[planVoulu] || 0;

          let daysLeft = Math.floor((endDate - today) / (1000 * 60 * 60 * 24));
          if (daysLeft < 0) daysLeft = 0;

          let bonusDays = 0;

          if (planActuel === "الأسطورية" && [1, 2, 3].includes(planVoulu)) {
            bonusDays = daysLeft * 2;
          } else if (
            planActuel === "المتطورة" &&
            [5, 6, 7].includes(planVoulu)
          ) {
            bonusDays = Math.ceil(daysLeft / 2);
          } else if (
            (planActuel === "الأسطورية" && [5, 6, 7].includes(planVoulu)) ||
            (planActuel === "المتطورة" && [1, 2, 3].includes(planVoulu))
          ) {
            bonusDays = 0;
          }

          const baseDate = daysLeft > 0 ? endDate : today;
          const totalDays = planDuration + bonusDays;
          const newEndDate = new Date(baseDate);
          newEndDate.setDate(newEndDate.getDate() + totalDays);

          return newEndDate;
        }

        const today = new Date();

        switch (Number(formData.plan)) {
          case 0:
            try {
              await updateDoc(doc(db, "account", account.id), {
                "subscription.tokens": increment(formData.numberOfOrders),
              });
              console.log("Mise à jour réussie الاساسية !");
            } catch (error) {
              console.error("Erreur lors de la mise à jour :", error);
            }
            break;

          case 1:
            try {
              const newEndDate = getNewEndDate(plan, 1, endDate, today);
              await updateDoc(doc(db, "account", account.id), {
                "subscription.plan": "المتطورة",
                "subscription.endDate": Timestamp.fromDate(newEndDate),
              });
              console.log("المتطورة maj 1 !");
            } catch (error) {
              console.error("Erreur lors de la mise à jour :", error);
            }
            break;

          case 2:
            try {
              const newEndDate = getNewEndDate(plan, 2, endDate, today);
              await updateDoc(doc(db, "account", account.id), {
                "subscription.plan": "المتطورة",
                "subscription.endDate": Timestamp.fromDate(newEndDate),
              });
              console.log("المتطورة maj 2 !");
            } catch (error) {
              console.error("Erreur lors de la mise à jour :", error);
            }
            break;

          case 3:
            try {
              const newEndDate = getNewEndDate(plan, 3, endDate, today);
              await updateDoc(doc(db, "account", account.id), {
                "subscription.plan": "المتطورة",
                "subscription.endDate": Timestamp.fromDate(newEndDate),
              });
              console.log("المتطورة maj 3 !");
            } catch (error) {
              console.error("Erreur lors de la mise à jour :", error);
            }
            break;

          case 5:
            try {
              const newEndDate = getNewEndDate(plan, 5, endDate, today);
              await updateDoc(doc(db, "account", account.id), {
                "subscription.plan": "الأسطورية",
                "subscription.endDate": Timestamp.fromDate(newEndDate),
              });
              console.log("الأسطورية maj 5 !");
            } catch (error) {
              console.error("Erreur lors de la mise à jour :", error);
            }
            break;

          case 6:
            try {
              const newEndDate = getNewEndDate(plan, 6, endDate, today);
              await updateDoc(doc(db, "account", account.id), {
                "subscription.plan": "الأسطورية",
                "subscription.endDate": Timestamp.fromDate(newEndDate),
              });
              console.log("الأسطورية maj 6 !");
            } catch (error) {
              console.error("Erreur lors de la mise à jour :", error);
            }
            break;

          case 7:
            try {
              const newEndDate = getNewEndDate(plan, 7, endDate, today);
              await updateDoc(doc(db, "account", account.id), {
                "subscription.plan": "الأسطورية",
                "subscription.endDate": Timestamp.fromDate(newEndDate),
              });
              console.log("الأسطورية maj 7 !");
            } catch (error) {
              console.error("Erreur lors de la mise à jour :", error);
            }
            break;
        }
      }

      // Update user points
      await updateDoc(doc(db, "account", account.id), {
        points: remainingPoints,
      });

      // Extract subscription name
      const subscriptionNames = {
        0: "باقة الاساسية",
        1: "باقة المتطورة شهري",
        2: "باقة المتطورة 3 أشهر",
        3: "باقة المتطورة سنوي (تخفيض 20%)",
        4: "باقة الأسطورية شهري",
        5: "باقة الأسطورية 3 أشهر",
        6: "باقة الأسطورية سنوي",
      };

      const subscriptionName =
        subscriptionNames[subscriptionType] || "اشتراك غير معروف";
      const transactionMessage = `${t(
        "createNotification1"
      )} ${finalAmount} ${t("createNotification2")} ${subscriptionName}`;

      await createNotification(
        account.user,
        transactionMessage,
        "transaction",
        "user"
      );
    } catch (error) {
      console.error("حدث خطأ أثناء معالجة المعاملة:", error);
    }
  };

  const [value, setValue] = useState(100);

  return (
    <div
      className="container-fluid dark:!bg-[#141414]"
      dir={t("settings.direction")}
    >
      <div className="row">
        {showSideBar && (
          <div style={{ width: "250px", flexShrink: 0 }}>
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 px-3-1 dark:!bg-[#141414]"
          style={{
            flex: 1,
            backgroundColor: "#f5f7f9",
          }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
          <div className="phone1">
            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-purple-100 dark:!border-[#3c3a3d] flex flex-col gap-y-6">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                  <h2 className="text-xl font-bold text-[#9e68ba] dark:!text-[#9e68ba] mb-0">
                    {t("PlanPage.subscription_title")}
                  </h2>
                  <p className="text-gray-600 dark:!text-gray-400 mb-0">
                    {t("PlanPage.payment_subtitle")}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm py-10 m-3 border border-purple-100 dark:!border-[#3c3a3d]">
              <div className="mx-auto px-4">
                <ul
                  aria-label={t("ui.steps")}
                  className="items-center text-gray-600 dark:!text-gray-300 font-medium flex"
                >
                  {steps.stepsItems.map((item, idx) => (
                    <li
                      key={idx}
                      aria-current={
                        steps.currentStep == idx + 1 ? "step" : false
                      }
                      className="flex gap-x-3 flex-col flex-1"
                    >
                      <div className="flex flex-row flex-1">
                        <hr
                          className={`w-full border1 block ${idx == 0
                              ? "border-none"
                              : "" || steps.currentStep >= idx + 1
                                ? "border-[#9e68ba]"
                                : "dark:!border-[#3c3a3d]"
                            }`}
                        />
                        <div
                          className={`w-8 h-8 rounded-full border-2 flex-none flex items-center justify-center ${steps.currentStep > idx + 1
                              ? "bg-[#9e68ba] border-[#9e68ba]"
                              : "" || steps.currentStep == idx + 1
                                ? "border-[#9e68ba]"
                                : "dark:!border-[#3c3a3d]"
                            }`}
                        >
                          <span
                            className={`w-2.5 h-2.5 rounded-full bg-[#9e68ba] ${steps.currentStep != idx + 1 ? "hidden" : ""
                              }`}
                          ></span>
                          {steps.currentStep > idx + 1 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="w-5 h-5 text-white"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M4.5 12.75l6 6 9-13.5"
                              />
                            </svg>
                          ) : (
                            ""
                          )}
                        </div>
                        <hr
                          className={`w-full ${idx + 1 == steps.stepsItems.length
                              ? "border-none"
                              : "" || steps.currentStep > idx + 1
                                ? "border-[#9e68ba]"
                                : "dark:!border-[#3c3a3d]"
                            }`}
                        />
                      </div>
                      <div className="h-8 flex justify-center items-center mt-3">
                        <h3
                          className={`text-sm ${steps.currentStep == idx + 1
                              ? "text-[#9e68ba]"
                              : "dark:!text-gray-300"
                            }`}
                        >
                          {item}
                        </h3>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <Form onSubmit={handleSubmit} className="">
              <div className="row mx-2">
                <div
                  className={`col-7-7 p-0 ${steps.currentStep === 4 ? "hidden" : ""
                    }`}
                >
                  <Card
                    className={`px-2-3 other-box dark:!bg-[#181819] dark:!border-[#3c3a3d] ${steps.currentStep === 4 ? "hidden" : ""
                      }`}
                  >
                    {steps.currentStep === 1 && (
                      <>
                        <div>
                          <p className="fs-3-6 dark:!text-[#9e68ba]">
                            {t("PlanPage.step1.title")}
                          </p>
                          <div className="dark:!bg-[#181819] dark:!text-gray-300 p-3 rounded-lg">
                            <p className="fs-5-5">
                              {t("PlanPage.step1.basicPlan")}
                            </p>
                            <div className="row dark:!bg-[#181819]">
                              <div className="col-4 dark:!bg-[#181819]">
                                <Form.Group
                                  controlId="formBasicName"
                                  className="d-flex align-items-center"
                                >
                                  <Form.Control
                                    type="number"
                                    placeholder=""
                                    value={formData.numberOfOrders}
                                    min="100"
                                    max="9999"
                                    className="dark:!bg-[#141414] dark:!text-gray-200 dark:!border-[#3c3a3d] dark:focus:!border-[#9e68ba]"
                                    onChange={(e) => {
                                      const inputValue = parseInt(
                                        e.target.value
                                      );
                                      if (!isNaN(inputValue)) {
                                        setFormData({
                                          ...formData,
                                          plan: 0,
                                          numberOfOrders: inputValue,
                                          total: parseInt(
                                            formData.unitPrice * inputValue
                                          ),
                                        });
                                      }
                                    }}
                                    onBlur={(e) => {
                                      const inputValue = parseInt(
                                        e.target.value
                                      );
                                      if (
                                        isNaN(inputValue) ||
                                        inputValue < 100
                                      ) {
                                        setFormData({
                                          ...formData,
                                          plan: 0,
                                          numberOfOrders: 100,
                                          total: parseInt(
                                            formData.unitPrice * 100
                                          ),
                                        });
                                      } else {
                                        setFormData({
                                          ...formData,
                                          numberOfOrders: inputValue,
                                          plan: 0,
                                          planName: "الاساسية",
                                          total: parseInt(
                                            formData.unitPrice * inputValue
                                          ),
                                        });
                                      }
                                    }}
                                  />
                                </Form.Group>
                              </div>

                              {/* Prix unitaire */}
                              <div className="col-4 s3">
                                <div className="d-flex justify-content-between">
                                  <p className="dark:!text-gray-400">
                                    {t("PlanPage.step1.unitPrice")}
                                  </p>
                                  <p className="dark:!text-gray-200">
                                    {isAlgeria
                                      ? `${formData.unitPrice} ${t("currency")}`
                                      : `${(formData.unitPrice / 235).toFixed(
                                        2
                                      )} $`}
                                  </p>
                                </div>
                              </div>

                              {/* Total */}
                              <div className="col-4 s3">
                                <div className="d-flex justify-content-between">
                                  <p className="dark:!text-gray-400">
                                    {t("PlanPage.step1.total")}
                                  </p>
                                  <p className="dark:!text-gray-200">
                                    {isAlgeria
                                      ? `${formData.unitPrice *
                                      formData.numberOfOrders
                                      } ${t("currency")}`
                                      : `$ ${(
                                        (formData.unitPrice *
                                          formData.numberOfOrders) /
                                        235
                                      ).toFixed(2)}`}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="fs-3-5 dark:!bg-[#181819] dark:!text-gray-300 p-3 rounded-lg">
                            <p className="fs-5-5">
                              {t("PlanPage.step1.advancedPlan")}
                            </p>
                            <div className="row">
                              {/* Plan Mensuel */}
                              <div className="col-12 col-sm-4 my-1">
                                <ul className="mt-6 space-y-3">
                                  <li>
                                    <label className="block relative">
                                      <input
                                        type="radio"
                                        checked={formData.plan === 1}
                                        onClick={downpage}
                                        onChange={() => {
                                          setFormData({
                                            ...formData,
                                            plan: 1,
                                            total: 2900,
                                            total1: 2900,
                                            planName: "باقة المتطورة",
                                          });
                                        }}
                                        name="payment"
                                        className={`sr-only peer absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      />
                                      <div
                                        className={`absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      >
                                        <svg
                                          className="w-2.5 h-2.5"
                                          viewBox="0 0 12 10"
                                        >
                                          <polyline
                                            fill="none"
                                            strokeWidth="2px"
                                            stroke="currentColor"
                                            strokeDasharray="16px"
                                            points="1.5 6 4.5 9 10.5 1"
                                          ></polyline>
                                        </svg>
                                      </div>

                                      <div className="w-full flex flex-col md:flex-row items-center gap-x-3 p-4 cursor-pointer rounded-lg border bg-white dark:!bg-[#141414] dark:!border-[#3c3a3d] shadow-sm ring-purple-400 peer-checked:ring-2 duration-200">
                                        <div className="flex-none"></div>
                                        <div>
                                          <h3
                                            className={`leading-none text-gray-800 dark:!text-gray-200 font-medium ${isRTL ? "pl-3" : "pr-3"
                                              }`}
                                          >
                                            {t("PlanPage.step1.monthly")}
                                          </h3>
                                          <p className="cvv dark:!text-gray-300">
                                            {isAlgeria
                                              ? `2900  ${t("currency")}`
                                              : "12.89 $"}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                </ul>
                              </div>

                              {/* Plan 3 mois */}
                              <div className="col-12 col-sm-4 my-1">
                                <ul className="mt-6 space-y-3">
                                  <li>
                                    <label className="block relative">
                                      <input
                                        type="radio"
                                        checked={formData.plan === 2}
                                        onClick={downpage}
                                        onChange={() => {
                                          setFormData({
                                            ...formData,
                                            plan: 2,
                                            total: 7200,
                                            total1: 7200,
                                            planName: "باقة المتطورة",
                                          });
                                        }}
                                        name="payment"
                                        className={`sr-only peer absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      />
                                      <div
                                        className={`absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      >
                                        <svg
                                          className="w-2.5 h-2.5"
                                          viewBox="0 0 12 10"
                                        >
                                          <polyline
                                            fill="none"
                                            strokeWidth="2px"
                                            stroke="currentColor"
                                            strokeDasharray="16px"
                                            points="1.5 6 4.5 9 10.5 1"
                                          ></polyline>
                                        </svg>
                                      </div>
                                      <div className="w-full flex flex-col md:flex-row gap-x-3 items-start p-4 cursor-pointer rounded-lg border bg-white dark:!bg-[#141414] dark:!border-[#3c3a3d] shadow-sm ring-purple-400 peer-checked:ring-2 duration-200">
                                        <div className="flex-none"></div>
                                        <div>
                                          <h3
                                            className={`leading-none text-gray-800 dark:!text-gray-200 font-medium ${isRTL ? "pl-3" : "pr-3"
                                              }`}
                                          >
                                            {t(
                                              "PlanPage.step1.threeMonthsDiscount17"
                                            )}
                                          </h3>
                                          <p className="cvv dark:!text-gray-300">
                                            {isAlgeria
                                              ? `7200 ${t("currency")}`
                                              : "32.00 $"}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                </ul>
                              </div>

                              {/* Plan Annuel */}
                              <div className="col-12 col-sm-4 my-1">
                                <ul className="mt-6 space-y-3">
                                  <li>
                                    <label className="block relative">
                                      <input
                                        type="radio"
                                        checked={formData.plan === 3}
                                        onClick={downpage}
                                        onChange={() => {
                                          setFormData({
                                            ...formData,
                                            plan: 3,
                                            total: 27500,
                                            total1: 27500,
                                            planName: "باقة المتطورة",
                                          });
                                        }}
                                        name="payment"
                                        className={`sr-only peer absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      />
                                      <div
                                        className={`absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      >
                                        <svg
                                          className="w-2.5 h-2.5"
                                          viewBox="0 0 12 10"
                                        >
                                          <polyline
                                            fill="none"
                                            strokeWidth="2px"
                                            stroke="currentColor"
                                            strokeDasharray="16px"
                                            points="1.5 6 4.5 9 10.5 1"
                                          ></polyline>
                                        </svg>
                                      </div>
                                      <div className="w-full flex flex-col md:flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border bg-white dark:!bg-[#141414] dark:!border-[#3c3a3d] shadow-sm ring-purple-400 peer-checked:ring-2 duration-200">
                                        <div className="flex-none"></div>
                                        <div>
                                          <h3
                                            className={`leading-none text-gray-800 dark:!text-gray-200 font-medium ${isRTL ? "pl-3" : "pr-3"
                                              }`}
                                          >
                                            {t(
                                              "PlanPage.step1.yearlyDiscount20"
                                            )}
                                          </h3>
                                          <p className="cvv dark:!text-gray-300">
                                            {isAlgeria
                                              ? `27500.${t("currency")}`
                                              : "122.22 $"}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div className="fs-3-5 dark:!bg-[#181819] dark:!text-gray-300 p-3 rounded-lg">
                            <p className="fs-5-5">
                              {t("PlanPage.step1.legendaryPlan")}
                            </p>
                            <div className="row">
                              {/* Mensuel */}
                              <div className="col-12 col-sm-4 my-1">
                                <ul className="mt-6 space-y-3">
                                  <li>
                                    <label className="block relative cursor-pointer">
                                      <input
                                        type="radio"
                                        checked={formData.plan === 5}
                                        onClick={downpage}
                                        onChange={() => {
                                          setFormData({
                                            ...formData,
                                            plan: 5,
                                            total: 5900,
                                            total1: 5900,
                                            planName: "الباقة الأسطورية",
                                          });
                                        }}
                                        name="payment"
                                        className={`sr-only peer absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      />

                                      <div
                                        className={`absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      >
                                        <svg
                                          className="w-2.5 h-2.5"
                                          viewBox="0 0 12 10"
                                        >
                                          <polyline
                                            fill="none"
                                            strokeWidth="2px"
                                            stroke="currentColor"
                                            strokeDasharray="16px"
                                            points="1.5 6 4.5 9 10.5 1"
                                          ></polyline>
                                        </svg>
                                      </div>

                                      <div className="w-full flex flex-row md:flex-row items-start gap-x-3 p-4 rounded-lg border bg-white dark:!bg-[#141414] dark:!border-[#3c3a3d] shadow-sm ring-purple-400 peer-checked:ring-2 duration-200">
                                        <Image
                                          src="https://cdn-icons-png.flaticon.com/128/6369/6369589.png"
                                          alt={t("ui.image")}
                                          width={50}
                                          height={50}
                                        />
                                        <div>
                                          <h3
                                            className={`leading-none text-gray-800 dark:!text-gray-200 font-medium ${isRTL ? "pl-3" : "pr-3"
                                              }`}
                                          >
                                            {t(
                                              "PlanPage.step1.legendaryMonthly"
                                            )}
                                          </h3>
                                          <p className="cvv dark:!text-gray-300">
                                            {isAlgeria
                                              ? `5900.${t("currency")}`
                                              : "26.22 $"}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                </ul>
                              </div>

                              {/* 3 mois */}
                              <div className="col-12 col-sm-4 my-1">
                                <ul className="mt-6 space-y-3">
                                  <li>
                                    <label className="block relative">
                                      <input
                                        type="radio"
                                        checked={formData.plan === 6}
                                        onClick={downpage}
                                        onChange={() => {
                                          setFormData({
                                            ...formData,
                                            plan: 6,
                                            total: 15000,
                                            total1: 15000,
                                            planName: "الباقة الأسطورية",
                                          });
                                        }}
                                        name="payment"
                                        className={`sr-only peer absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      />
                                      <div
                                        className={`absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      >
                                        <svg
                                          className="w-2.5 h-2.5"
                                          viewBox="0 0 12 10"
                                        >
                                          <polyline
                                            fill="none"
                                            strokeWidth="2px"
                                            stroke="currentColor"
                                            strokeDasharray="16px"
                                            points="1.5 6 4.5 9 10.5 1"
                                          ></polyline>
                                        </svg>
                                      </div>

                                      <div className="w-full flex flex-col md:flex-row gap-x-3 items-start p-4 cursor-pointer rounded-lg border bg-white dark:!bg-[#141414] dark:!border-[#3c3a3d] shadow-sm ring-purple-400 peer-checked:ring-2 duration-200">
                                        <div className="flex-none"></div>
                                        <div>
                                          <h3
                                            className={`leading-none text-gray-800 dark:!text-gray-200 font-medium ${isRTL ? "pl-3" : "pr-3"
                                              }`}
                                          >
                                            {t(
                                              "PlanPage.step1.threeMonthsDiscount15"
                                            )}
                                          </h3>
                                          <p className="cvv dark:!text-gray-300">
                                            {isAlgeria
                                              ? `15000.${t("currency")}`
                                              : "66.67 $"}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                </ul>
                              </div>

                              {/* Annuel */}
                              <div className="col-12 col-sm-4 my-1">
                                <ul className="mt-6 space-y-3">
                                  <li>
                                    <label className="block relative">
                                      <input
                                        type="radio"
                                        checked={formData.plan === 7}
                                        onClick={downpage}
                                        onChange={() => {
                                          setFormData({
                                            ...formData,
                                            plan: 7,
                                            total: 59000,
                                            total1: 59000,
                                            planName: "الباقة الأسطورية",
                                          });
                                        }}
                                        name="payment"
                                        className={`sr-only peer absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      />
                                      <div
                                        className={`absolute top-4 ${isRTL ? "left-4" : "right-4"
                                          } flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf] text-white peer-checked:text-white duration-200`}
                                      >
                                        <svg
                                          className="w-2.5 h-2.5"
                                          viewBox="0 0 12 10"
                                        >
                                          <polyline
                                            fill="none"
                                            strokeWidth="2px"
                                            stroke="currentColor"
                                            strokeDasharray="16px"
                                            points="1.5 6 4.5 9 10.5 1"
                                          ></polyline>
                                        </svg>
                                      </div>
                                      <div className="w-full flex flex-col md:flex-row md:gap-x-3 md:items-start p-4 cursor-pointer rounded-lg border bg-white dark:!bg-[#141414] dark:!border-[#3c3a3d] shadow-sm ring-purple-400 peer-checked:ring-2 duration-200">
                                        <div className="flex-none"></div>
                                        <div>
                                          <h3
                                            className={`leading-none text-gray-800 dark:!text-gray-200 font-medium ${isRTL ? "pl-3" : "pr-3"
                                              }`}
                                          >
                                            {t(
                                              "PlanPage.step1.yearlyDiscount30"
                                            )}
                                          </h3>
                                          <p className="cvv dark:!text-gray-300">
                                            {isAlgeria
                                              ? `59000.${t("currency")}`
                                              : "262.22 $"}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div className="fs-5-5 dark:!bg-[#181819] dark:!text-gray-300 p-3 rounded-lg">
                            <p className="fs-5">
                              {t("PlanPage.step1.proPlan")}
                            </p>
                            <div className="row">
                              <div className="col-12 col-sm-4 my-1">
                                <ul className="mt-6 space-y-3">
                                  <li>
                                    <label className="block relative">
                                      <div className="w-full flex flex-col md:flex-row gap-x-3 items-start p-4 cursor-pointer rounded-lg border bg-white dark:!bg-[#141414] dark:!border-[#3c3a3d] shadow-sm ring-purple-400 peer-checked:ring-2 duration-200">
                                        <div>
                                          <h3 className="leading-none text-gray-800 dark:!text-gray-200 font-medium pl-3">
                                            {t("PlanPage.step1.proAnnual")}
                                          </h3>
                                          <p className="cvv dark:!text-gray-300">
                                            {t("PlanPage.step1.proContact")}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div className="text-start my-2">
                            <Link to={`/subscription`}>
                              <button className="px-7 py-1.5 text-sm2 text-gray-700 dark:!bg-[#9e68ba] dark:!text-white duration-100 border11 rounded-lg hover:border-[#5a2b73] active:shadow-lg1">
                                {t("PlanPage.step1.cancel")}
                              </button>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}

                    {steps.currentStep === 2 && (
                      <div>
                        <div>
                          {/*------------------------------------------------------------------------------------*/}
                          <div className="max-w-md1 mx-auto ">
                            <h2 className="text-gray-800 dark:!text-gray-200 font-medium">
                              {t("PlanPage.step2.title")}
                            </h2>
                            <ul className="mt-6 space-y-3">
                              <li>
                                <label className="block relative">
                                  <input
                                    type="radio"
                                    checked={formData.paymentMethod === 1}
                                    onChange={() => {
                                      setFormData({
                                        ...formData,
                                        paymentMethod: 1,
                                      });
                                    }}
                                    name="payment"
                                    className="sr-only peer absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200"
                                  />
                                  <div className="absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200">
                                    <svg
                                      className="w-2.5 h-2.5"
                                      viewBox="0 0 12 10"
                                    >
                                      <polyline
                                        fill="none"
                                        stroke-width="2px"
                                        stroke="currentColor"
                                        stroke-dasharray="16px"
                                        points="1.5 6 4.5 9 10.5 1"
                                      ></polyline>
                                    </svg>
                                  </div>
                                  {isAlgeria && (
                                    <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-sm ring-indigo-600 peer-checked:ring-2 duration-200 kk">
                                      <div className="flex-none">
                                        <Image
                                          src="/logo-round.png"
                                          alt={t("ui.image")}
                                          width={50}
                                          height={50}
                                        />
                                      </div>
                                      <div>
                                        <h3 className="leading-none text-gray-800 dark:!text-gray-400 font-medium pl-3">
                                          {t("PlanPage.step2.payment1")}
                                        </h3>
                                        <p className="mt-1 text-sm text-gray-600 dark:!text-gray-500">
                                          {t("PlanPage.step2.payment1Hint")}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </label>
                                <label className="block relative">
                                  <input
                                    type="radio"
                                    checked={formData.paymentMethod === 2}
                                    onChange={() => {
                                      setFormData({
                                        ...formData,
                                        paymentMethod: 2,
                                      });
                                    }}
                                    name="payment"
                                    className="sr-only peer absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200"
                                  />
                                  <div className="absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200">
                                    <svg
                                      className="w-2.5 h-2.5"
                                      viewBox="0 0 12 10"
                                    >
                                      <polyline
                                        fill="none"
                                        stroke-width="2px"
                                        stroke="currentColor"
                                        stroke-dasharray="16px"
                                        points="1.5 6 4.5 9 10.5 1"
                                      ></polyline>
                                    </svg>
                                  </div>
                                  {isAlgeria && (
                                    <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-sm ring-indigo-600 peer-checked:ring-2 duration-200 kk">
                                      <div className="flex-none">
                                        <Image
                                          src="/baridimob.png"
                                          alt={t("ui.image")}
                                          width={50}
                                          height={40}
                                        />
                                      </div>
                                      <div>
                                        <h3 className="leading-none text-gray-800 dark:!text-gray-400 font-medium pl-3">
                                          {t("PlanPage.step2.payment2")}
                                        </h3>
                                        <p className="mt-1 text-sm text-gray-600 dark:!text-gray-500">
                                          {t("PlanPage.step2.payment2Hint")}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </label>
                                <label className="block relative">
                                  <input
                                    type="radio"
                                    checked={formData.paymentMethod === 3}
                                    onChange={() => {
                                      setFormData({
                                        ...formData,
                                        paymentMethod: 3,
                                      });
                                    }}
                                    name="payment"
                                    className="sr-only peer absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200"
                                  />
                                  <div className="absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200">
                                    <svg
                                      className="w-2.5 h-2.5"
                                      viewBox="0 0 12 10"
                                    >
                                      <polyline
                                        fill="none"
                                        stroke-width="2px"
                                        stroke="currentColor"
                                        stroke-dasharray="16px"
                                        points="1.5 6 4.5 9 10.5 1"
                                      ></polyline>
                                    </svg>
                                  </div>
                                  <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] ring-indigo-600 peer-checked:ring-2 duration-200 kk shadow-md  ">
                                    <div className="flex-none">
                                      <Image
                                        src="/Dukascopy.png"
                                        alt={t("ui.image")}
                                        width={40}
                                        height={40}
                                      />
                                    </div>
                                    <div className="flex-grow">
                                      <h3 className="leading-none text-gray-500 dark:!text-gray-400 font-medium pl-3">
                                        {t("PlanPage.step2.payment3")}
                                      </h3>
                                      <p className="mt-1 text-sm text-gray-500 dark:!text-gray-500">
                                        {t("PlanPage.step2.payment3Hint")}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                                <label className="block relative">
                                  <input
                                  disabled
                                    type="radio"
                                    checked={formData.paymentMethod === 4}
                                    onChange={() => {
                                      setFormData({
                                        ...formData,
                                        paymentMethod: 4,
                                      });
                                    }}
                                    name="payment"
                                    // disabled
                                    className="sr-only peer absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200"
                                  />
                                  <div className="absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200">
                                    <svg
                                      className="w-2.5 h-2.5"
                                      viewBox="0 0 12 10"
                                    >
                                      <polyline
                                        fill="none"
                                        stroke-width="2px"
                                        stroke="currentColor"
                                        stroke-dasharray="16px"
                                        points="1.5 6 4.5 9 10.5 1"
                                      ></polyline>
                                    </svg>
                                  </div>
                                  <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] ring-indigo-600 peer-checked:ring-2 duration-200 kk shadow-md  ">
                                    <div className="flex-none">
                                      <Image
                                        src="/wise.png"
                                        alt={t("ui.image")}
                                        width={40}
                                        height={40}
                                      />
                                    </div>
                                    <div className="flex-grow">
                                      <h3 className="leading-none text-gray-500 dark:!text-gray-400 font-medium pl-3">
                                        {t("PlanPage.step2.payment4")}
                                      </h3>
                                      <p className="mt-1 text-sm text-gray-500 dark:!text-gray-500">
                                        {t("PlanPage.step2.payment4Hint")}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                                <label className="block relative">
                                  <input
                                    type="radio"
                                    checked={formData.paymentMethod === 5}
                                    onChange={() => {
                                      setFormData({
                                        ...formData,
                                        paymentMethod: 5,
                                      });
                                    }}
                                    name="payment"
                                    className="sr-only peer absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200"
                                  />
                                  <div className="absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200">
                                    <svg
                                      className="w-2.5 h-2.5"
                                      viewBox="0 0 12 10"
                                    >
                                      <polyline
                                        fill="none"
                                        stroke-width="2px"
                                        stroke="currentColor"
                                        stroke-dasharray="16px"
                                        points="1.5 6 4.5 9 10.5 1"
                                      ></polyline>
                                    </svg>
                                  </div>
                                  <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-sm ring-indigo-600 peer-checked:ring-2 duration-200 kk">
                                    <div className="flex-none">
                                      <Image
                                        src="https://www.redotpay.com/img/favicon.png"
                                        alt={t("ui.image")}
                                        width={50}
                                        height={50}
                                      />
                                    </div>
                                    <div>
                                      <h3 className="leading-none text-gray-800 dark:!text-gray-400 font-medium pl-3">
                                        {t("PlanPage.step2.payment5")}
                                      </h3>
                                      <p className="mt-1 text-sm text-gray-600 dark:!text-gray-500">
                                        {t("PlanPage.step2.payment3Hint")}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                                <label className="block relative">
                                  <input
                                    type="radio"
                                    checked={formData.paymentMethod === 6}
                                    onChange={() => {
                                      setFormData({
                                        ...formData,
                                        paymentMethod: 6,
                                      });
                                    }}
                                    name="payment"
                                    className="sr-only peer absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200"
                                  />
                                  <div className="absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200">
                                    <svg
                                      className="w-2.5 h-2.5"
                                      viewBox="0 0 12 10"
                                    >
                                      <polyline
                                        fill="none"
                                        stroke-width="2px"
                                        stroke="currentColor"
                                        stroke-dasharray="16px"
                                        points="1.5 6 4.5 9 10.5 1"
                                      ></polyline>
                                    </svg>
                                  </div>
                                  <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-sm ring-indigo-600 peer-checked:ring-2 duration-200 kk">
                                    <div className="flex-none">
                                      <Image
                                        src="https://www.rivianforums.com/forum/attachments/9e4a3983-4691-4bfb-9fa1-7fc3e5100874-jpeg.36042/"
                                        alt={t("ui.image")}
                                        width={50}
                                        height={50}
                                      />
                                    </div>
                                    <div>
                                      <h3 className="leading-none text-gray-800 dark:!text-gray-400 font-medium pl-3">
                                        {t("PlanPage.step2.payment6")}
                                      </h3>
                                      <p className="mt-1 text-sm text-gray-600 dark:!text-gray-500">
                                        {t("PlanPage.step2.payment3Hint")}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                                <label className="block relative">
                                  <input
                                    type="radio"
                                    checked={formData.paymentMethod === 7}
                                    onChange={() => {
                                      setFormData({
                                        ...formData,
                                        paymentMethod: 7,
                                      });
                                    }}
                                    name="payment"
                                    className="sr-only peer absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200"
                                  />
                                  <div className="absolute top-4 left1-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-[#9b59bf]  text-white peer-checked:text-white duration-200">
                                    <svg
                                      className="w-2.5 h-2.5"
                                      viewBox="0 0 12 10"
                                    >
                                      <polyline
                                        fill="none"
                                        stroke-width="2px"
                                        stroke="currentColor"
                                        stroke-dasharray="16px"
                                        points="1.5 6 4.5 9 10.5 1"
                                      ></polyline>
                                    </svg>
                                  </div>
                                  <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-sm ring-indigo-600 peer-checked:ring-2 duration-200 kk">
                                    <div className="flex-none">
                                      <Image
                                        src="https://cdn-icons-png.flaticon.com/128/1770/1770992.png"
                                        alt={t("ui.image")}
                                        width={50}
                                        height={50}
                                      />
                                    </div>
                                    <div>
                                      <h3 className="leading-none text-gray-800 dark:!text-gray-400 font-medium pl-3">
                                        {t("PlanPage.step2.payment7")}
                                      </h3>
                                      <p className="mt-1 text-sm text-gray-600 dark:!text-gray-500">
                                        {t("PlanPage.step2.payment3Hint")}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="text-start my-2">
                          <Link to={`/subscription`}>
                            <button className="px-7 py-1.5 text-sm2 text-gray-700 dark:!bg-[#9e68ba] dark:!text-white duration-100 border11 rounded-lg hover:border-[#5a2b73] active:shadow-lg1">
                              {t("PlanPage.step2.cancel")}
                            </button>
                          </Link>
                        </div>
                      </div>
                    )}

                    {steps.currentStep === 3 && (
                      <div>
                        {/* <p className='fs-4'>الدفع عن طريق
                          {formData.paymentMethod === 1 && ' البريد السريع CCP'}
                          {formData.paymentMethod === 2 && ' بريدي موب'}
                          {formData.paymentMethod === 3 && ' Dukascopy'}
                        </p>
                        <p className='fs-4-4'>للدفع عن
                          {formData.paymentMethod === 1 && ' البريد السريع CCP'}
                          {formData.paymentMethod === 2 && ' بريدي موب'}
                          {formData.paymentMethod === 3 && ' Dukascopy'}
                          ، قم بتحويل المبلغ المستحق  <span className='bg-success'>
                            {formData.paymentMethod === 1 && (`${formData.total} ${t("currency")} `) || formData.paymentMethod === 2 && (`${formData.total} ${t("currency")} `)}
                            {formData.paymentMethod === 3 && (`€ ${(formData.total / 235).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`)}
                            {formData.paymentMethod === 3 && (`€ ${(formData.total / 235 - 1.5).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`)}
                          </span> لحساب فوورويب وإرفاق إيصال الحوالة البنكية.</p>*/}

                        <div>
                          {/*---------------------------------------------------------------------------------------------------*/}
                          <section className="max-w-xl py-12 mx-auto px-4 text-[17px] md:px-8">
                            <div className="space-y-3 text-center">
                              {formData.paymentMethod === 1 && (
                                <Image
                                  src={"/logo-round.png"}
                                  alt={t("ui.image")}
                                  width={50}
                                  height={50}
                                  className="marginauto"
                                />
                              )}
                              {formData.paymentMethod === 2 && (
                                <Image
                                  src={"/baridimob.png"}
                                  alt={t("ui.image")}
                                  width={45}
                                  height={40}
                                  className="marginauto"
                                />
                              )}
                              {formData.paymentMethod === 3 && (
                                <Image
                                  src={"/Dukascopy.png"}
                                  alt={t("ui.image")}
                                  width={120}
                                  height={100}
                                  className="marginauto"
                                />
                              )}
                              {formData.paymentMethod === 4 && (
                                <Image
                                  src={"/wise.png"}
                                  alt={t("ui.image")}
                                  width={50}
                                  height={28}
                                  className="marginauto"
                                />
                              )}
                              {formData.paymentMethod === 5 && (
                                <Image
                                  src={
                                    "https://support.redotpay.com/hc/theming_assets/01HZH5N38PA5A6YMMMX2WVQNSC"
                                  }
                                  alt={t("ui.image")}
                                  width={130}
                                  height={30}
                                  className="marginauto"
                                />
                              )}
                              {formData.paymentMethod === 6 && (
                                <Image
                                  src={
                                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkT5jX2eBez5xg383OwIPAQZe7eZpvuy1JUg&s"
                                  }
                                  alt={t("ui.image")}
                                  width={130}
                                  height={30}
                                  className="marginauto"
                                />
                              )}
                              {formData.paymentMethod === 7 && (
                                <Image
                                  src={
                                    "https://cdn-icons-png.flaticon.com/128/1770/1770992.png"
                                  }
                                  alt={t("ui.image")}
                                  width={50}
                                  height={50}
                                  className="marginauto"
                                />
                              )}
                              <h3 className="text-3xl text-gray-800 dark:!text-gray-300 font-bold">
                                {t("PlanPage.step3.title")}
                                {formData.paymentMethod === 1 &&
                                  t("foorchat.stats.ccp")}
                                {formData.paymentMethod === 2 && t("PlanPage.step2.payment2")}
                                {formData.paymentMethod === 3 && t("PlanPage.step2.payment3")}
                                {formData.paymentMethod === 4 && t("paymentMethods.methodsList.wise.name")}
                                {formData.paymentMethod === 5 && t("foorchat.stats.redotpay")}
                                {formData.paymentMethod === 6 && t("PlanPage.step2.payment6")}
                                {formData.paymentMethod === 7 &&
                                  t("ui.europeanBank")}
                              </h3>
                              <p className="text-gray-400 leading-relaxed">
                                {t("PlanPage.step3.paymentIntro")}
                                {formData.paymentMethod === 1 &&
                                  t("foorchat.stats.ccp")}
                                {formData.paymentMethod === 2 && t("PlanPage.step2.payment2")}
                                {formData.paymentMethod === 3 && t("PlanPage.step2.payment3")}
                                {formData.paymentMethod === 4 &&
                                  t("ui.wiseTransfer")}
                                {formData.paymentMethod === 5 && t("foorchat.stats.redotpay")}
                                {formData.paymentMethod === 6 && t("PlanPage.step2.payment6")}
                                {formData.paymentMethod === 7 &&
                                  t("ui.europeanBank")}
                                {t("PlanPage.step3.amountNote")}
                                <span className="bg-success">
                                  {(formData.paymentMethod === 1 &&
                                    `${formData.total} ${t("currency")} `) ||
                                    (formData.paymentMethod === 2 &&
                                      `${formData.total} ${t("currency")} `)}
                                  {formData.paymentMethod === 3 &&
                                    `€ ${(formData.total / 235).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}`}
                                  {formData.paymentMethod === 4 &&
                                    `€ ${(formData.total / 235).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}`}
                                  {formData.paymentMethod === 5 &&
                                    `€ ${(formData.total / 235).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}`}
                                  {formData.paymentMethod === 6 &&
                                    `€ ${(formData.total / 235).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}`}
                                  {formData.paymentMethod === 7 &&
                                    `€ ${(formData.total / 235).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}`}
                                </span>
                                {t("PlanPage.step3.paymentEndNote")}
                              </p>
                            </div>
                            <div className="mt-5">
                              <div
                                className="dark:!bg-[#181819]"
                                style={{ width: "100%" }}
                              >
                                <div className="d-flex mt-2">
                                  {formData.paymentMethod === 1 && (
                                    <Form.Control
                                      className="dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                                      type="text"
                                      value="0043101520 cle 41 BENKHEDDA AHMED"
                                      readOnly
                                    />
                                  )}
                                  {formData.paymentMethod === 2 && (
                                    <Form.Control
                                      className="dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                                      type="text"
                                      value="00799999004310152041"
                                      readOnly
                                    />
                                  )}
                                  {formData.paymentMethod === 3 && (
                                    <Form.Control
                                      className="dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                                      type="text"
                                      value="+213667849950"
                                      readOnly
                                    />
                                  )}
                                  {formData.paymentMethod === 4 && (
                                    <Form.Control
                                      className="dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                                      type="text"
                                      value="Beneficiary name and surname  :  m Ayoub Benaouda
                                      Beneficiary address : cite mokhbat, 1, 19, 09000, Blida
                                      Beneficiary bank account number : CH4308843125935321010
                                      SWIFT/ BIC code : DUBACHGG
                                      Beneficiary bank address  : Route de Pré-Bois 20, 1215 Geneva, Switzerland"
                                      readOnly
                                    />
                                  )}
                                  {formData.paymentMethod === 5 && (
                                    <Form.Control
                                      className="dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                                      type="text"
                                      value="1546009587"
                                      readOnly
                                    />
                                  )}
                                  {formData.paymentMethod === 6 && (
                                    <Form.Control
                                      className="dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                                      type="text"
                                      value="foorwebs@gmail.com"
                                      readOnly
                                    />
                                  )}
                                  {formData.paymentMethod === 7 && (
                                    <Form.Control
                                      className="dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                                      type="text"
                                      value="Beneficiary name and surname  :  m Ayoub Benaouda
                                            Beneficiary address : cite mokhbat, 1, 19, 09000, Blida
                                            Beneficiary bank account number : CH4308843125935321010
                                            SWIFT/ BIC code : DUBACHGG
                                            Beneficiary bank address  : Route de Pré-Bois 20, 1215 Geneva, Switzerland"
                                      readOnly
                                    />
                                  )}
                                  <Button
                                    className="bi bi-back btn  btn-outline-secondary"
                                    onClick={handleClick}
                                  ></Button>
                                </div>
                              </div>

                              <p className="mt-3 mx-auto text-center max-w-lg text-[15px] text-gray-400">
                                {t("PlanPage.step3.warning")}
                                <a
                                  className="text-indigo-600 underline"
                                  href="javascript:void(0)"
                                >
                                  {" "}
                                  {t("PlanPage.step3.privacyPolicy")}{" "}
                                </a>
                              </p>
                            </div>
                          </section>

                          {/*---------------------------------------------------------------------------------------------------*/}
                        </div>

                        <div>
                          <p className="text-3xl text-gray-800 dark:text-gray-200 font-bold">
                            {" "}
                            {t("PlanPage.step3.uploadTitle")}{" "}
                          </p>
                          <p className="text-gray-400 leading-relaxed">
                            {t("PlanPage.step3.uploadDescription")}
                          </p>
                          <Form.Group className="mb-3 col-12 text-center">
                            <Form.Label>{t("ui.test")}</Form.Label>
                            <Form.Control
                              type="file"
                              className="pp1 dark:!bg-[#181819] dark:!text-gray-400 dark:!border-[#3c3a3d]"
                              onChange={(e) =>
                                uploadImage2([e.target.files[0]], "main")
                              }
                            />
                            {!!formData.proof && (
                              <div className="img-wrap">
                                <Image
                                  width="200px"
                                  height="200px"
                                  className="text-center mt-2"
                                  src={formData.proof}
                                />
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="d-flex justify-content-between my-2">
                          <div></div>

                          <div className="text-start my-2">
                            <Link to={`/subscription`}>
                              <button className="px-7 py-1.5 text-sm2 text-gray-700 dark:!bg-[#9e68ba] dark:!text-white duration-100 border11 rounded-lg hover:border-[#5a2b73] active:shadow-lg1">
                                {t("PlanPage.step3.cancel")}
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                  </Card>
                </div>

                <div className="col-5-5" id="target">
                  <div
                    className={`px-2-3 other-box rounded-lg bg-white dark:!bg-[#181919] dark:!border dark:!border-[#3c3a3d] ${steps.currentStep === 4 ? "hidden" : ""
                      }`}
                  >
                    <p className="fs-3-6 text-gray-800 dark:text-[#9e68ba]">
                      {t("PlanPage.summary.title")}
                    </p>

                    {/* Section plan */}
                    <div className="d-flex ks-2 justify-content-between py-3 text-gray-500 dark:text-gray-300">
                      <p>
                        {formData.planName}
                        {formData.total === 2900 &&
                          t("PlanPage.summary.monthly")}
                        {formData.total === 7200 &&
                          t("PlanPage.summary.quarterly")}
                        {formData.total === 27500 &&
                          t("PlanPage.summary.yearly")}
                      </p>
                      <p>
                        {(formData.paymentMethod === 1 &&
                          `${formData.total} ${t("currency")} `) ||
                          (formData.paymentMethod === 2 &&
                            `${formData.total} ${t("currency")} `)}
                        {formData.paymentMethod === 3 &&
                          `€ ${(formData.total / 245).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        {formData.paymentMethod === 4 &&
                          `€ ${(formData.total / 245).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        {formData.paymentMethod === 5 &&
                          `$ ${(formData.total / 235).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        {formData.paymentMethod === 6 &&
                          `$ ${(formData.total / 235).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        {formData.paymentMethod === 7 &&
                          `€ ${(formData.total / 245).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                      </p>
                    </div>
                    <hr className="m-0 p-0 border-gray-200 dark:!border-[#3c3a3d]" />

                    {/* Remise */}
                    <div className="d-flex ks-2 justify-content-between py-3 text-gray-500 dark:text-gray-300">
                      <p>{t("PlanPage.summary.discount")}</p>
                      <p>
                        {formData.remise > 0
                          ? `${(formData.total * formData.remise) / 100} ${t(
                            "currency"
                          )}`
                          : "0.0"}
                      </p>
                    </div>
                    <hr className="m-0 p-0 border-gray-200 dark:!border-[#3c3a3d]" />

                    {/* Total */}
                    <div className="d-flex ks-2 justify-content-between py-3 text-gray-500 dark:text-gray-300">
                      <p>{t("PlanPage.summary.total")}</p>
                      <p>
                        {(formData.paymentMethod === 1 &&
                          `${formData.total1 ? formData.total1 : formData.total
                          } ${t("currency")} `) ||
                          (formData.paymentMethod === 2 &&
                            `${formData.total1 ? formData.total1 : formData.total
                            } ${t("currency")} `)}
                        {formData.paymentMethod === 3 &&
                          `€ ${(
                            (formData.total1
                              ? formData.total1
                              : formData.total) / 245
                          ).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        {/* idem pour 4,5,6,7 */}
                      </p>
                    </div>
                    <hr className="text-success1 border-gray-200 dark:!border-[#3c3a3d]" />

                    {/* Due */}
                    <div className="d-flex ks-2-2 justify-content-between text-gray-500 dark:text-gray-300">
                      <p className="f-8">{t("PlanPage.summary.due")}</p>
                      <p className="f-8">
                        {(formData.paymentMethod === 1 &&
                          `${formData.total1 ? formData.total1 : formData.total
                          } ${t("currency")} `) ||
                          (formData.paymentMethod === 2 &&
                            `${formData.total1 ? formData.total1 : formData.total
                            } ${t("currency")} `)}
                        {/* idem conversion €/$ */}
                      </p>
                    </div>

                    {/* Points utilisateur */}
                    {points > 0 && (
                      <>
                        <div className="d-flex ks-2 justify-content-between py-3 text-gray-500 dark:text-gray-300">
                          <p>{t("PlanPage.summary.userPoints")}</p>
                          <p>
                            {points} {t("PlanPage.summary.point")}
                          </p>
                        </div>

                        <div className="d-flex ks-2 justify-content-between py-3 text-gray-500 dark:text-gray-300">
                          <p>{t("PlanPage.summary.amountAfterPoints")}</p>
                          <p>{finalAmount} {t("ui.dzd")}</p>
                        </div>

                        <div className="d-flex ks-2 justify-content-between py-3 text-gray-500 dark:text-gray-300">
                          <p>{t("PlanPage.summary.usedPoints")}</p>
                          <p>
                            {usedPoints} {t("PlanPage.summary.point")}
                          </p>
                        </div>
                      </>
                    )}

                    {/* Coupon */}
                    {steps.currentStep === 1 && (
                      <div className="">
                        <label className="text-[#444] dark:text-gray-200 text-[13px] font-medium mb-1">
                          {t("PlanPage.summary.couponLabel")}
                        </label>
                        <div className="relative mb-6">
                          <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#d5d5d5"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-badge-percent"
                            >
                              <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                              <path d="m15 9-6 6" />
                              <path d="M9 9h.01" />
                              <path d="M15 15h.01" />
                            </svg>
                          </div>
                          <input
                            value={formData.invitedBy}
                            onChange={handleInvitedByChange}
                            placeholder={t(
                              "PlanPage.summary.couponPlaceholder"
                            )}
                            className="border border-gray-200 dark:!border-[#3c3a3d] bg-white dark:!bg-[#141414] text-gray-900 dark:text-gray-200 text-sm rounded-lg block w-full pr-10 p-2.5 focus:outline-none focus:ring-2 focus:ring-purple-200"
                          />
                        </div>

                        {!isExist && (
                          <p style={{ color: "#e87778" }}>{errorMessage}</p>
                        )}
                      </div>
                    )}

                    {/* Progress bar */}
                    <div className="my-2">
                      <div className="flex justify-between my-1">
                        <span className="text-base font-medium text-blue-700 dark:text-white">
                          {t("PlanPage.summary.trustLabel")}
                        </span>
                        <span className="text-sm font-medium text-blue-700 dark:text-white">
                          {nbrTransaction >= 2
                            ? "90%"
                            : `${(nbrTransaction / 2) * 85}%`}
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2.5 dark:!bg-gray-700">
                        <div
                          className="bg-blue-600 h-2.5 rounded-full"
                          style={{
                            width:
                              nbrTransaction >= 2
                                ? "90%"
                                : `${(nbrTransaction / 2) * 90}%`,
                          }}
                        ></div>
                      </div>

                      {/* Cartes confiance */}
                      <div
                        className={`mt-3 p-3 rounded-lg border ${nbrTransaction >= 2
                            ? "bg-green-50 border-green-200"
                            : "bg-yellow-50 border-yellow-200"
                          } dark:!bg-[#181919] dark:!border-[#3c3a3d]`}
                      >
                        {nbrTransaction >= 2 ? (
                          <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#16a34a"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <polyline points="22 4 12 14.01 9 11.01" />
                              </svg>
                              <span className="text-green-700 dark:text-green-400 font-medium">
                                {t("PlanPage.summary.trusted.title")}
                              </span>
                            </div>
                            <p className="text-green-700 dark:text-green-400 text-sm">
                              {t("PlanPage.summary.trusted.activation")}
                            </p>
                            <p className="text-green-600 dark:text-green-300 text-xs">
                              {t("PlanPage.summary.trusted.warning")}
                            </p>
                          </div>
                        ) : (
                          <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#ca8a04"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12.01" y2="16" />
                              </svg>
                              <span className="text-yellow-700 dark:text-yellow-400 font-medium">
                                {nbrTransaction === 0
                                  ? t("PlanPage.summary.notTrusted.title1")
                                  : t("PlanPage.summary.notTrusted.title2", {
                                    count: 2 - nbrTransaction,
                                  })}
                              </span>
                            </div>
                            <p className="text-yellow-700 dark:text-yellow-400 text-sm">
                              {t("PlanPage.summary.notTrusted.check")}
                            </p>
                            <p className="text-yellow-600 dark:text-yellow-300 text-xs">
                              {t("PlanPage.summary.notTrusted.advice")}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Boutons */}
                    <div className="flex-col gap-y-4 text-center">
                      {/* continue */}
                      <button
                        className={`text-white flex justify-center focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-3 text-center inline-flex items-center me-2 mb-2 ${steps.currentStep === 3 || steps.currentStep === 4
                            ? "hidden"
                            : !isExist ||
                              formData.invitedBy === account?.callName
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-[#9b59bf] hover:bg-[#522868]"
                          }`}
                        onClick={nextStep}
                        type="button"
                        style={{ width: "100%" }}
                        disabled={
                          (steps.currentStep === 1 &&
                            (!isExist ||
                              formData.invitedBy === account?.callName)) ||
                          steps.currentStep === 3 ||
                          steps.currentStep === 4
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-step-back"
                        >
                          <line x1="18" x2="18" y1="20" y2="4" />
                          <polygon points="14,20 4,12 14,4" />
                        </svg>
                        {t("PlanPage.summary.continue")}
                      </button>

                      {/* submit */}
                      <button
                        className={`text-white flex justify-center focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-3 text-center items-center me-2 mb-2 ${steps.currentStep === 1 ||
                            steps.currentStep === 2 ||
                            steps.currentStep === 4
                            ? "hidden"
                            : ""
                          } ${isSuraUploaded
                            ? "bg-[#9b59bf] hover:bg-[#522868]"
                            : "bg-gray-400 cursor-not-allowed"
                          }`}
                        variant="primary"
                        type="submit"
                        onClick={nextStep}
                        disabled={!isSuraUploaded}
                        style={{ width: "100%" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-square-check-big ml-1"
                        >
                          <path d="M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5" />
                          <path d="m9 11 3 3L22 4" />
                        </svg>
                        {t("PlanPage.summary.submit")}
                      </button>

                      {/* back */}
                      <button
                        className={`text-white flex justify-center focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-3 text-center items-center me-2 mb-2 ${steps.currentStep === 1 || steps.currentStep === 4
                            ? "hidden"
                            : ""
                          } bg-[#62748e] hover:bg-[#45556c]`}
                        onClick={prevStep}
                        type="button"
                        style={{ width: "100%" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-step-forward"
                        >
                          <line x1="6" x2="6" y1="4" y2="20" />
                          <polygon points="10,4 20,12 10,20" />
                        </svg>
                        {t("PlanPage.summary.back")}
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className={`col-7-8 p-0 ${steps.currentStep === 1 ||
                      steps.currentStep === 2 ||
                      steps.currentStep === 3
                      ? "hidden"
                      : ""
                    }`}
                >
                  <Card className={`other-box dark:!border-[#3c3a3d] `}>
                    {steps.currentStep === 4 && (
                      <section
                        className="py-28 bg-[#141414] dark:!bg-[#141414]"
                        style={{
                          background:
                            "linear-gradient(152.92deg, rgba(192, 132, 252, 0.2) 4.54%, rgba(232, 121, 249, 0.17) 34.2%, rgba(192, 132, 252, 0.1) 77.55%)",
                        }}
                      >
                        <div className="max-w-screen-xl mx-auto px-4 text-center px-8">
                          <div className="max-w-xl space-y-3 mx-auto bg-white dark:!bg-[#181919] border dark:!border-[#3c3a3d] rounded-xl p-6">
                            <h3 className="text-[#825ba0] font-semibold dark:text-[#cfa8e7]">
                              {t("PlanPage.confirmation.subtitle")}
                            </h3>
                            <p className="text-gray-800 text-3xl font-semibold text-4xl dark:text-white">
                              {t("PlanPage.confirmation.title")}
                            </p>
                            <p className="text-gray-600 dark:text-gray-400">
                              {t("PlanPage.confirmation.description")}
                            </p>
                          </div>
                          <div className="mt-4">
                            <Link to={`/subscription`}>
                              <button className="px-3 py-3 rounded-lg font-semibold text-sm duration-150 text-white bg-[#9b59bf] dark:hover:!bg-[#9b59bf] hover:bg-indigo-500  active:bg-indigo-700">
                                {t("PlanPage.confirmation.button")}
                              </button>
                            </Link>
                          </div>
                        </div>
                      </section>
                    )}
                  </Card>
                </div>
              </div>
            </Form>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Plan;
